import swal from 'sweetalert2'

const state = () => ({
  loading: false,
  permissions: null,
  activeRole: null
})

const getters = {}

const actions = {
  async resendInvitation ({rootState}, memberId) {
    try {
      await axios.get(`api/projects/${rootState.projects.project.id}/members/resend-invitation/${memberId}`)
      await swal.fire({
        icon: 'success',
        iconColor: '#4F83E3',
        title: 'Invitation resend successfully',
        showConfirmButton: false,
        toast: true,
        position: 'top-right',
        timer: 3500
      })
    } catch (error) {
      console.error('Error sending email', error)
      if (error.response && error.response?.data?.message.includes('You can send the next invitation via')) {
        await swal.fire({
          icon: 'error',
          title: error.response?.data?.message,
          showConfirmButton: false,
          toast: true,
          position: 'top-right',
          timer: 3500
        })
      }
    }
  },
  async getProjectPermissions ({state}, id) {
    state.loading = true
    try {
      const {data} = await axios.get(`api/projects/${id}/members/current-member/permissions`)
      return data.data
    } catch (error) {
      console.error('Error fetching project permissions:', error)
    } finally {
      state.loading = false
    }
  },
  async getPermissions ({state, rootState}) {
    state.loading = true
    try {
      const {data} = await axios.get(`api/projects/${rootState.projects.project.id}/members/roles/permissions`)
      state.permissions = data.data
    } catch (error) {
      console.error('Error fetching permissions:', error)
    } finally {
      state.loading = false
    }
  },
  async getRoles ({state, rootState}) {
    state.loading = true
    try {
      const {data} = await axios.get(`api/projects/${rootState.projects.project.id}/members/roles`)
      return data.data
    } catch (error) {
      console.error('Error fetching roles:', error)
    } finally {
      state.loading = false
    }
  },
  async getRole ({state, rootState}, id) {
    state.loading = true
    try {
      const {data} = await axios.get(`api/projects/${rootState.projects.project.id}/members/roles/${id}`)
      return data.data
    } catch (error) {
      console.error(`Error fetching role #${id}:`, error)
    } finally {
      state.loading = false
    }
  },
  async createRole ({state, rootState}, payload) {
    state.loading = true
    try {
      await axios.post(`api/projects/${rootState.projects.project.id}/members/roles`, payload)
    } catch (error) {
      console.error('Error create role:', error)
    } finally {
      state.loading = false
    }
  },
  async updateRole ({state, rootState}, payload) {
    state.loading = true
    try {
      await axios.put(`api/projects/${rootState.projects.project.id}/members/roles/${payload.id}`, payload.body)
    } catch (error) {
      console.error(`Error updating role ${payload.id}:`, error)
    } finally {
      state.loading = false
    }
  },
  async deleteRole ({state, rootState}, id) {
    state.loading = true
    try {
      await axios.delete(`api/projects/${rootState.projects.project.id}/members/roles/${id}`)
    } catch (error) {
      console.error(`Error delete role #${id}:`, error)
    } finally {
      state.loading = false
    }
  },
  async getMembers ({state, rootState}) {
    state.loading = true
    try {
      const {data} = await axios.get(`api/projects/${rootState.projects.project.id}/members`)
      return data.data
    } catch (error) {
      console.error('Error fetching members:', error)
    } finally {
      state.loading = false
    }
  },
  async getMember ({state, rootState}, id) {
    state.loading = true
    try {
      const {data} = await axios.get(`api/projects/${rootState.projects.project.id}/members/${id}`)
      return data.data
    } catch (error) {
      console.error(`Error fetching member #${id}:`, error)
    } finally {
      state.loading = false
    }
  },
  async createMember ({state, rootState}, payload) {
    state.loading = true
    try {
      await axios.post(`api/projects/${rootState.projects.project.id}/members`, payload)
    } catch (error) {
      console.error('Error create member:', error)
    } finally {
      state.loading = false
    }
  },
  async updateMember ({state, rootState}, payload) {
    state.loading = true
    try {
      await axios.put(`api/projects/${rootState.projects.project.id}/members/${payload.id}`, payload.body)
    } catch (error) {
      console.error(`Error updating member ${payload.id}:`, error)
    } finally {
      state.loading = false
    }
  },
  async deleteMember ({state, rootState}, id) {
    state.loading = true
    try {
      await axios.delete(`api/projects/${rootState.projects.project.id}/members/${id}`)
    } catch (error) {
      console.error(`Error delete member #${id}:`, error)
    } finally {
      state.loading = false
    }
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}